module.exports = __webpack_public_path__ + "static/media/tour-time-yellow.3074a99b.svg";